var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChoosePrizeDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 130 109"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ChoosePrizeDesktop_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M71.905 108.426c31.784 0 57.55-1.728 57.55-3.859s-25.766-3.859-57.55-3.859-57.55 1.727-57.55 3.859 25.766 3.859 57.55 3.859"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "M23.645 80.514s.57 9.943 4.507 18.877l-3.53 3.031c-.562.481-.226 1.41.509 1.41H42.6l-.338-23.365z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C3FBF1",
  d: "M39.695 80.46s3.694 13.22 8.559 18.894l-3.531 3.032c-.561.481-.225 1.41.51 1.41l15.639.073h2.448c-2.65-12.26-2.783-23.319-2.783-23.319l-20.84-.09z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C3FBF1",
  d: "M68.306 22.852H14.434c-3.838 0-6.95 3.156-6.95 7.05v46.647c0 3.894 3.112 7.05 6.95 7.05h53.872c3.838 0 6.95-3.156 6.95-7.05V29.901c0-3.893-3.112-7.049-6.95-7.049"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5BCFF",
  d: "m128.058 104.273-56.624-.108.383-86.237 56.624.109z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8591FE",
  d: "m128.055 104.273-18.297-.034 8.097-86.223 10.584.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5BCFF",
  d: "M101.316 20.24c1.612 1.162 5.504-.912 8.692-4.634s4.466-7.684 2.853-8.847c-1.613-1.164-5.96-3.102-9.148.62-3.189 3.724-4.01 11.697-2.397 12.861m3.761-10.608c1.88-2.195 4.442-1.051 5.393-.366.951.686.198 3.021-1.681 5.216-1.881 2.196-4.175 3.42-5.126 2.733-.952-.685-.467-5.388 1.414-7.583"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5BCFF",
  d: "M93.984 17.145c2.445 2.753 5.398 4.258 6.594 3.361s.472-6.878-1.973-9.63-5.687-1.235-6.883-.337c-1.197.897-.185 3.855 2.262 6.606m-.584-5.393c.67-.5 2.479-1.349 3.846.189s1.772 4.88 1.104 5.38c-.67.501-2.318-.338-3.685-1.876-1.365-1.538-1.932-3.19-1.264-3.692z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "M61.005 22.852h7.845c3.535 0 6.406 2.912 6.406 6.499v47.057c0 3.969-3.176 7.19-7.089 7.19h-7.163V22.853"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF662F",
  d: "m49.09 13.006-3.704 1.836c-.35.269-.946.165-1.112-.193l-3.1-4.562c-.334-.727-1.671-.727-2.007 0l-3.184 4.593c-.166.36-.762.463-1.112.193l-3.728-1.913c-.425-.327-1.15-.096-1.15.365l2.98 6.616c0 .417.575.535 1.055.52l12.137-.004c.49.025 1.038-.034 1.032-.444l3.044-6.646c-.006-.46-.728-.686-1.15-.361z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M47.29 40.855H30.228a9.7 9.7 0 0 0-.97 4.247c0 5.322 4.254 9.637 9.502 9.637 5.247 0 9.5-4.315 9.5-9.637a9.7 9.7 0 0 0-.969-4.247m-6.308 11.798c-2.015.558-4.12-.74-4.12-.74s1.162-2.203 3.177-2.762 4.12.739 4.12.739-1.162 2.204-3.177 2.763M27.618 42.411q0 .276-.052.535h-5.217a2.8 2.8 0 0 1-.052-.535c0-1.489 1.191-2.697 2.66-2.697s2.66 1.208 2.66 2.697zM56.313 42.412q0 .274-.052.534h-5.217a2.8 2.8 0 0 1-.052-.535c0-1.488 1.192-2.697 2.661-2.697s2.66 1.209 2.66 2.697"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5BCFF",
  d: "M21.432 53.94H.891v20.838h20.541z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8591FE",
  d: "M21.435 74.778h-4.303L14.57 53.94h6.865z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5BCFF",
  d: "M9.36 46.562c-1.765-2.236-4.139-1.037-5.017-.323-.878.713-.159 3.104 1.607 5.34 1.765 2.236 3.908 3.47 4.787 2.757.878-.714.389-5.538-1.377-7.775zm.076 5.956c-.518.421-1.781-.306-2.823-1.626s-1.465-2.728-.947-3.15c.517-.419 1.916-1.126 2.957.192 1.042 1.319 1.33 4.163.812 4.583z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5BCFF",
  d: "M15.946 48.407c-.66-.536-2.444-1.438-3.77.244-1.328 1.68-1.696 5.307-1.035 5.843.659.536 2.27-.392 3.597-2.072s1.868-3.478 1.208-4.014m-1.589 2.988c-.742.939-1.641 1.457-2.01 1.158s-.163-2.326.578-3.265c.742-.939 1.738-.435 2.108-.136.368.3.066 1.304-.675 2.243"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#717171",
  strokeMiterlimit: 10,
  strokeWidth: 0.503,
  d: "M6.852 78.294c.392.75.973 1.23 1.636 1.259.846.036 1.619-.673 2.071-1.763.236-.563.384-1.23.414-1.948a5.8 5.8 0 0 0-.21-1.846c-.346-1.196-1.078-2.025-1.956-2.064-.543-.022-1.053.26-1.47.75"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#717171",
  d: "m5.703 71.423-.01.25c.522.023 1.02.393 1.389 1.058.366.661.58 1.578.538 2.591l.25.011.252.01c.045-1.09-.182-2.1-.6-2.855-.416-.75-1.045-1.284-1.808-1.316zm2.168 3.91-.251-.01c-.043 1.013-.332 1.908-.752 2.535-.423.631-.95.957-1.472.934l-.01.251-.011.251c.763.033 1.434-.444 1.91-1.156.48-.716.791-1.704.837-2.794zm-2.486 3.71.01-.25c-.521-.023-1.02-.393-1.389-1.058-.366-.661-.58-1.577-.537-2.591l-.251-.01-.251-.012c-.046 1.09.182 2.102.6 2.856.415.75 1.044 1.284 1.808 1.317zm-2.167-3.91.25.01c.043-1.013.332-1.908.752-2.535.423-.631.951-.957 1.473-.934l.01-.251.01-.251c-.762-.033-1.434.444-1.91 1.156-.48.716-.79 1.704-.836 2.794z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#717171",
  strokeMiterlimit: 10,
  strokeWidth: 0.503,
  d: "M10.766 73.997c.452-1.09 1.223-1.797 2.07-1.762.72.031 1.34.593 1.731 1.45M10.563 77.79c.345 1.195 1.077 2.027 1.956 2.065.914.038 1.742-.79 2.174-2.03"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#717171",
  strokeMiterlimit: 10,
  strokeWidth: 0.503,
  d: "M17.56 75.586c.072-1.704-.625-3.117-1.556-3.157-.571-.025-1.097.473-1.438 1.257.31.674.476 1.532.438 2.46a6 6 0 0 1-.312 1.68c.274.465.642.754 1.055.772.931.04 1.744-1.309 1.815-3.012z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6F6F6",
  d: "M17.127 9.54c-5.522.008-7.989 1.346-8.006 8.762.018-7.416-3.551-8.761-7.953-8.77 4.321.01 7.953-.744 7.953-8.752 0 8.008 2.484 8.769 8.006 8.762z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#717171",
  strokeMiterlimit: 10,
  strokeWidth: 0.503,
  d: "M68.606 61.664c6.792 5.804 10.933 6.375 11.709 7.186.24.252-.763 2.684-.118 3.097.382.245 2.64-1.431 3.01-1.147.965.74 4.402 1.731 5.95 1.361.22-.053-2.543-1.904-2.313-2.045.312-.192 3.344.313 3.67-.078.117-.14-3.19-1.557-3.072-1.726.25-.356 3.467-1.172 3.643-1.51.188-.359-3.548-1.085-3.437-1.42.111-.337 2.853-1.277 2.896-1.588.291-2.13-2.542-.434-4.1-.915-3.533-1.092-6.594-2.647-14.76-12.842"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ChoosePrizeDesktop_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h130v109H0z"
})))));
export default SvgChoosePrizeDesktop;